(function($){
    var appearDistance = '90%';
  if($('.whyGennet')[0]) {
    var whyGennetWaypoint = new Waypoint({
      element: $('.whyGennet'),
      handler: function(direction) {
        $('.whyGennet').animateCSS();
        $('.whyGennet li').animateCSS({delay: 100, stepDelay: 100})
      },
      offset: appearDistance
    });
  }
}(jQuery));